import { useGetFoldersByTeam, useProjects } from '@/dc-shared-web/src'

export const useDashboardListState = (
  selectedTeamId: string,
  canViewExplorers: boolean,
  page: 'dashboard' | 'folder'
) => {
  const folders = useGetFoldersByTeam(
    {
      teamUuid: selectedTeamId,
    },
    //don't fetch folders if they are not currently visible
    {
      enabled: !!canViewExplorers,
    }
  )
  const projects = useProjects({
    params: {
      currentTeamUuid: selectedTeamId,
      currentTable: page,
      page,
    },
    //don't fetch projects if they are not currently visible
    options: {
      enabled: !!canViewExplorers,
    },
  })

  return {
    isLoading: folders.isLoading || projects.isLoading,
    foldersCount: folders.data?.length ?? 0,
    projectsCount: projects.data?.length ?? 0,
  }
}
